"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _masterTheme = _interopRequireDefault(require("../../themes/masterTheme"));

var _luna = _interopRequireDefault(require("../../themes/luna"));

var _globalStyle = _interopRequireDefault(require("../GlobalStyle/globalStyle"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Base = function Base(_ref) {
  var children = _ref.children,
      luna = _ref.luna;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: luna ? _objectSpread(_objectSpread({}, _masterTheme.default), _luna.default) : _masterTheme.default
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_globalStyle.default, {
    suppressMultiMountWarning: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ui-base"
  }, children)));
};

Base.propTypes = {
  /** Child content rendered with base styling. */
  children: _propTypes.default.node,

  /** Enables Luna Lite look and feel. */
  luna: _propTypes.default.bool
};
var _default = Base;
exports.default = _default;
//# sourceMappingURL=Base.js.map